import { createContext, ReactNode, useContext, useEffect, useState } from "react";
import { createBrowserHistory } from 'history';
import { auth, firebase } from '../services/firebase';
import { useHistory } from "react-router-dom";

interface User {
  id: string;
  name: string;
  avatar: string;
}

interface AuthContextType {
  user: User | undefined;
  signInWithGoogle: () => Promise<void>;
  signOut: () => Promise<void>;
}

interface AuthContextProviderProps {
  children: ReactNode;
}

const AuthContext = createContext({} as AuthContextType);

export function AuthContextProvider({ children }: AuthContextProviderProps) {
  const [user, setUser] = useState<User>()
  const [loading, setLoading] = useState(true)


  const urlHistory = createBrowserHistory();
  const path = urlHistory.location.pathname;

  async function signInWithGoogle() {
    const provider = new firebase.auth.GoogleAuthProvider();
    const result = await auth.signInWithPopup(provider);

    if (result.user) {
      const { displayName, photoURL, uid } = result.user;

      if (!displayName || !photoURL) {
        throw new Error('Missing information from Google Account.')
      }

      setUser({
        id: uid,
        name: displayName,
        avatar: photoURL,
      })
      setLoading(false);
    }
  }

  async function signOut() {
    setUser(undefined);
    await auth.signOut();
    setLoading(false);
  }

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged(user => {
      if (user) {
        const { displayName, photoURL, uid } = user;

        if (!displayName || !photoURL) {
          throw new Error('Missing information from Google Account.')
        }

        setUser({
          id: uid,
          name: displayName,
          avatar: photoURL,
        })
      }
    })
    //Esse return serve para fazer com que ele pare de ouvir(checar) se tem
    // alguem logado na comta ao final do useEffect, visto como uma boa pratica

    return () => {
      unsubscribe();
    }
  }, [])


  if (!user && loading && path !== '/') {
    return <p>Carregando...</p>
  }


  return (
    <AuthContext.Provider value={{ user, signInWithGoogle, signOut }}>
      {children}
    </AuthContext.Provider>
  )
}

export const useAuth = () => useContext(AuthContext);